export const USER_ROLES = {
  OWNER: "owner",
  ADMIN: "admin",
  MANAGER: "manager",
  USER: "user",
};

const ROLE_KEYS = new Set(Object.values(USER_ROLES));

export function normalizeUserRole(role) {
  const normalized = String(role || "").trim().toLowerCase();
  return ROLE_KEYS.has(normalized) ? normalized : null;
}

export function getCurrentUserRole(accountInfo = {}) {
  const roleCandidates = [
    accountInfo?.role,
    accountInfo?.userRole,
    accountInfo?.accountRole,
    accountInfo?.user?.role,
    accountInfo?.userAccount?.role,
    accountInfo?.account?.role,
  ];

  for (const candidate of roleCandidates) {
    const normalized = normalizeUserRole(candidate);
    if (normalized) return normalized;
  }

  if (accountInfo?.isOwner === true) return USER_ROLES.OWNER;
  if (accountInfo?.isAdmin === true) return USER_ROLES.ADMIN;
  return USER_ROLES.USER;
}

export function isOwnerOrAdminRole(role) {
  const normalized = normalizeUserRole(role);
  return (
    normalized === USER_ROLES.OWNER || normalized === USER_ROLES.ADMIN
  );
}

export function canAccessUpgradeRoute(role) {
  return isOwnerOrAdminRole(role);
}

export function canAccessManagerLevelFeatures(role) {
  const normalized = normalizeUserRole(role);
  return (
    normalized === USER_ROLES.OWNER ||
    normalized === USER_ROLES.ADMIN ||
    normalized === USER_ROLES.MANAGER
  );
}

export function canAccessSettingsIntegrations(role) {
  return isOwnerOrAdminRole(role);
}

export function canAccessSettingsUsers(role) {
  return isOwnerOrAdminRole(role);
}

export function canAccessSettingsSubscription(role) {
  return isOwnerOrAdminRole(role);
}

export function canAccessSettingsWebhooks(role) {
  return canAccessManagerLevelFeatures(role);
}

export function canAccessSettingsBudget(role) {
  return canAccessManagerLevelFeatures(role);
}

export function canAccessSettingsReports(role) {
  return canAccessManagerLevelFeatures(role);
}

export function canSyncLinkedin(role) {
  return canAccessManagerLevelFeatures(role);
}

export function canToggleCampaignAndAdsStatus(role) {
  return canAccessManagerLevelFeatures(role);
}

export function canGenerateInsights(role) {
  return canAccessManagerLevelFeatures(role);
}
